<div id="proposal-template">
    <div class="pdf-page">
        <div class="proposal-header">
            <div class="logo">
                <img src="{{entityData?.image ? logoPath + entityData?.image : ''}}" crossorigin="anonymous">
            </div>
            <div class="block">
                <h3>{{isSaleBusinessType ? 'Proposta de Aquisição' : 'Proposta de Arrendamento'}}
                </h3>
            </div>
        </div>
        <div class="property-info">
            <div class="proposal-item-normal">
                <div style="width: 70%;">
                    <span>Morada: {{deal.property?.location?.address}}</span>
                </div>
                <div style="width: 30%;">
                    <span>Ref: {{deal.property?.ref}}</span>
                </div>
            </div>
        </div>
        <div class="proposal-body">
            <div *ngFor="let proposer of proposalData?.proposers?.slice(0, 2)">
                <div class="proposal-item-head">
                    {{ proposer.type == 'INDIVIDUAL' ? 'Proponente (Pessoa Singular)' :
                    proposer.type == 'LEGAL' ? 'Proponente (pessoa coletiva)' : proposer.type == 'EFFECTIVE_BENEFICIARY' ?
                    'Beneficiários efetivos' : 'Proponente (Fiador)'}}
                </div>
                <div *ngIf="proposer.type != 'LEGAL'">
                    <div *ngFor="let item of itemsPage1" class="proposal-item-normal">
                        <div *ngFor="let sub of item.sub" [ngStyle]="{'width': sub.size + '%'}">
                            {{sub.name}}: {{getItemByFieldName(sub.fieldName, proposer, sub?.suffix)}}
                        </div>
                    </div>
                    <div class="proposal-item-normal">
                        <div style="width: 100%;font-size: 12px;" class="align-items-center d-flex">O(s) Proponente(s)
                            atua(m)
                            por: conta própria<input [attr.checked]="proposer.actionType == 'own' ? true : null"
                                type="checkbox" class="ms-2"><span class="ms-2">conta de outrém
                            </span>
                            <input [attr.checked]="proposer.actionType == 'OTHER' ? true : null" type="checkbox"
                                class="ms-2"><span class="ms-2">se
                                outrém, especifique </span><span *ngIf="proposer.actionTypeOther" class="ms-2" style="
                        text-decoration: underline;
                            ">{{proposer.actionTypeOther}}</span>
                        </div>
                    </div>
                    <div class="proposal-item-normal">
                        <div style="width: 100%;font-size: 12px;">O(s) proponente(s), seu(s)
                            representante(s) e/ou beneficiário(s) efetivo(s) desempenha(ram) nos últimos 12 meses cargos
                            de
                            natureza política ou
                            pública?<input [attr.checked]="proposer.politicalPositions === false ? true : null"
                                type="checkbox" class="ms-2"><span class="ms-2">Não
                            </span>
                            <input [attr.checked]="proposer.politicalPositions === true ? true : null" type="checkbox"
                                class="ms-2"><span class="ms-2">Sim
                            </span><span class="ms-2">se
                                sim, especifique </span><span
                                *ngIf="proposer.politicalDesc && proposer.politicalPositions === true" class="ms-2"
                                style="
                        text-decoration: underline;
                ">{{proposer.politicalDesc}}</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="proposer.type == 'LEGAL'">
                    <div *ngFor="let item of coletiveItems" class="proposal-item-normal">
                        <div *ngFor="let sub of item.sub" [ngStyle]="{'width': sub.size + '%'}">
                            {{sub.name}}: {{getItemByFieldName(sub.fieldName, proposer, sub?.suffix)}}
                        </div>
                    </div>
                    <div class="proposal-item-normal">
                        <div style="width: 100%;">
                            <span>Os Beneficiário(s) Efetivo(s) devem ser identificados no campo das pessoas singulares
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="proposal-footer">
            <span>{{entityData.name}}</span>
            <span>Página 1 de {{pagesCount}}</span>
        </div>
    </div>
    <div *ngIf="(proposalData?.proposers?.length ?? 0) > 2" class="pdf-page">
        <div class="proposal-header">
            <div class="logo">
                <img src="{{entityData?.image ? logoPath + entityData?.image : ''}}" crossorigin="anonymous">
            </div>
            <div class="block">
                <h3>{{isSaleBusinessType ? 'Proposta de Aquisição' : 'Proposta de Arrendamento'}}
                </h3>
            </div>
        </div>
        <div class="proposal-body">
            <div *ngFor="let proposer of proposalData?.proposers?.slice(2, 4)">
                <div class="proposal-item-head">
                    {{ proposer.type == 'INDIVIDUAL' ? 'Proponente (Pessoa Singular)' :
                    proposer.type == 'LEGAL' ? 'Proponente (pessoa coletiva)' : proposer.type == 'EFFECTIVE_BENEFICIARY' ?
                    'Beneficiários efetivos' : 'Proponente (Fiador)'}}
                </div>
                <div *ngIf="proposer.type != 'LEGAL'">
                    <div *ngFor="let item of itemsPage1" class="proposal-item-normal">
                        <div *ngFor="let sub of item.sub" [ngStyle]="{'width': sub.size + '%'}">
                            {{sub.name}}: {{getItemByFieldName(sub.fieldName, proposer, sub?.suffix)}}
                        </div>
                    </div>
                    <div class="proposal-item-normal">
                        <div style="width: 100%;font-size: 12px;" class="align-items-center d-flex">O(s) Proponente(s)
                            atua(m)
                            por: conta própria<input [attr.checked]="proposer.actionType == 'own' ? true : null"
                                type="checkbox" class="ms-2"><span class="ms-2">conta de outrém
                            </span>
                            <input [attr.checked]="proposer.actionType == 'OTHER' ? true : null" type="checkbox"
                                class="ms-2"><span class="ms-2">se
                                outrém, especifique </span><span *ngIf="proposer.actionTypeOther" class="ms-2" style="
                        text-decoration: underline;
                            ">{{proposer.actionTypeOther}}</span>
                        </div>
                    </div>
                    <div class="proposal-item-normal">
                        <div style="width: 100%;font-size: 12px;">O(s) proponente(s), seu(s)
                            representante(s) e/ou beneficiário(s) efetivo(s) desempenha(ram) nos últimos 12 meses cargos
                            de
                            natureza política ou
                            pública?<input [attr.checked]="proposer.politicalPositions === false ? true : null"
                                type="checkbox" class="ms-2"><span class="ms-2">Não
                            </span>
                            <input [attr.checked]="proposer.politicalPositions === true ? true : null" type="checkbox"
                                class="ms-2"><span class="ms-2">Sim
                            </span><span class="ms-2">se
                                sim, especifique </span><span *ngIf="proposer.politicalDesc" class="ms-2" style="
                        text-decoration: underline;
                ">{{proposer.politicalDesc}}</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="proposer.type == 'LEGAL'">
                    <div *ngFor="let item of coletiveItems" class="proposal-item-normal">
                        <div *ngFor="let sub of item.sub" [ngStyle]="{'width': sub.size + '%'}">
                            {{sub.name}}: {{getItemByFieldName(sub.fieldName, proposer, sub?.suffix)}}
                        </div>
                    </div>
                    <div class="proposal-item-normal">
                        <div style="width: 100%;">
                            <span>Os Beneficiário(s) Efetivo(s) devem ser identificados no campo das pessoas singulares
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="proposal-footer">
            <span>{{entityData.name}}</span>
            <span>Página 2 de {{pagesCount}}</span>
        </div>
    </div>
    <div *ngIf="proposalData && (proposalData?.proposers?.length ?? 0) > 4" class="pdf-page">
        <div class="proposal-header">
            <div class="logo">
                <img src="{{entityData?.image ? logoPath + entityData?.image : ''}}" crossorigin="anonymous">
            </div>
            <div class="block">
                <h3>{{isSaleBusinessType ? 'Proposta de Aquisição' : 'Proposta de Arrendamento'}}
                </h3>
            </div>
        </div>
        <div class="proposal-body">
            <div *ngFor="let proposer of proposalData?.proposers?.slice(4, 6)">
                <div class="proposal-item-head">
                    {{ proposer.type == 'INDIVIDUAL' ? 'Proponente (Pessoa Singular)' :
                    proposer.type == 'LEGAL' ? 'Proponente (pessoa coletiva)' : proposer.type == 'EFFECTIVE_BENEFICIARY' ?
                    'Beneficiários efetivos' : 'Proponente (Fiador)'}}
                </div>
                <div *ngIf="proposer.type != 'LEGAL'">
                    <div *ngFor="let item of itemsPage1" class="proposal-item-normal">
                        <div *ngFor="let sub of item.sub" [ngStyle]="{'width': sub.size + '%'}">
                            {{sub.name}}: {{getItemByFieldName(sub.fieldName, proposer, sub?.suffix)}}
                        </div>
                    </div>
                    <div class="proposal-item-normal">
                        <div style="width: 100%;font-size: 12px;" class="align-items-center d-flex">O(s) Proponente(s)
                            atua(m)
                            por: conta própria<input [attr.checked]="proposer.actionType == 'own' ? true : null"
                                type="checkbox" class="ms-2"><span class="ms-2">conta de outrém
                            </span>
                            <input [attr.checked]="proposer.actionType == 'OTHER' ? true : null" type="checkbox"
                                class="ms-2"><span class="ms-2">se
                                outrém, especifique </span><span *ngIf="proposer.actionTypeOther" class="ms-2" style="
                        text-decoration: underline;
                            ">{{proposer.actionTypeOther}}</span>
                        </div>
                    </div>
                    <div class="proposal-item-normal">
                        <div style="width: 100%;font-size: 12px;">O(s) proponente(s), seu(s)
                            representante(s) e/ou beneficiário(s) efetivo(s) desempenha(ram) nos últimos 12 meses cargos
                            de
                            natureza política ou
                            pública?<input [attr.checked]="proposer.politicalPositions === false ? true : null"
                                type="checkbox" class="ms-2"><span class="ms-2">Não
                            </span>
                            <input [attr.checked]="proposer.politicalPositions === true ? true : null" type="checkbox"
                                class="ms-2"><span class="ms-2">Sim
                            </span><span class="ms-2">se
                                sim, especifique </span><span *ngIf="proposer.politicalDesc" class="ms-2" style="
                        text-decoration: underline;
                ">{{proposer.politicalDesc}}</span>
                        </div>
                    </div>
                </div>
                <div *ngIf="proposer.type == 'LEGAL'">
                    <div *ngFor="let item of coletiveItems" class="proposal-item-normal">
                        <div *ngFor="let sub of item.sub" [ngStyle]="{'width': sub.size + '%'}">
                            {{sub.name}}: {{getItemByFieldName(sub.fieldName, proposer, sub?.suffix)}}
                        </div>
                    </div>
                    <div class="proposal-item-normal">
                        <div style="width: 100%;">
                            <span>Os Beneficiário(s) Efetivo(s) devem ser identificados no campo das pessoas singulares
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="proposal-footer">
            <span>{{entityData.name}}</span>
            <span>Página 3 de {{pagesCount}}</span>
        </div>
    </div>
    <div class="pdf-page">
        <div class="proposal-header">
            <div class="logo">
                <img src="{{entityData?.image ? logoPath + entityData?.image : ''}}" crossorigin="anonymous">
            </div>
            <div class="block">
                <h3>{{isSaleBusinessType ? 'Proposta de Aquisição' : 'Proposta de Arrendamento'}}
                </h3>
            </div>
        </div>
        <div class="proposal-body">
            <div class="proposal-item-head">
                Proposta
            </div>
            <div *ngIf="isSaleBusinessType; else rentItems">
                <div *ngFor="let item of itemsPage2" class="proposal-item-normal">
                    <div *ngFor="let sub of item.sub" [ngStyle]="{'width': sub.size + '%'}">
                        {{sub.name}}: {{getProposalItemByFieldName(sub.fieldName, proposalData, sub?.suffix)}}
                    </div>
                </div>
            </div>
            <ng-template #rentItems>
                <div *ngFor="let item of itemsPage2Rent" class="proposal-item-normal">
                    <div *ngFor="let sub of item.sub" [ngStyle]="{'width': sub.size + '%'}">
                        {{sub.name}}: {{getProposalItemByFieldName(sub.fieldName, proposalData, sub?.suffix)}}
                    </div>
                </div>
            </ng-template>
            <div class="proposal-item-head">
                Mediação
            </div>
            <div class="proposal-item-normal">
                <div style="width: 50%;">
                    Loja: {{proposalData.mediationStore}}
                </div>
                <div style="width: 50%;">
                    Responsável: {{proposalData.responsible}}
                </div>
            </div>
            <div class="proposal-item-head">
                Instruções de Preenchimento
            </div>
            <div class="proposal-item-normal">
                <div style="width: 100%; font-size: 11px;">
                    A proposta deve ser integralmente preenchida, de forma legível e sem rasuras
                </div>
            </div>
            <div class="proposal-item-normal">
                <div style="width: 100%; font-size: 11px;">
                    No campo Nacionalidade(s), caso haja mais do que uma, deverão ser todas indicadas
                </div>
            </div>

            <div class="proposal-item-normal">
                <div style="width: 100%; font-size: 11px;">
                    Quando o proponente for uma pessoa coletiva, os órgãos sociais deverão ser identificados nos
                    campos
                    de pessoas individuais
                </div>
            </div>

            <div class="proposal-item-normal">
                <div style="width: 100%; font-size: 11px;">
                    Quando os campos constantes na proposta não forem suficientes deverão ser preenchidas tantas
                    propostas quantas as necessárias
                </div>
            </div>

            <div class="proposal-item-normal">
                <div style="width: 100%; font-size: 11px;">
                    A inexatidão das informações inviabilizam a proposta
                </div>
            </div>
            <div class="proposal-item-head">
                Informações
            </div>
            <div class="proposal-item-normal">
                <div style="width: 100%; text-align: center; font-weight: 700;">
                    A presente proposta dá quitação aos valores entregues para reserva do imóvel.
                </div>
            </div>
            <div class="proposal-item-normal">
                <div style="width: 100%; text-align: center; font-weight: 700;">
                    Se aquisição com capitais próprios é necessário comprovativo da origem dos fundos
                </div>
            </div>

            <div class="proposal-item-normal">
                <div style="width: 100%; font-size: 11px;">
                    O(s) proponente(s) declara(m) expressamente que reconhece(m), na sua plenitude, as condições em
                    que
                    o imóvel se encontra e que, além de o aceitar no
                    estado em que está, reconhece(m) ainda que o preço de compra e venda aqui proposto tem em conta
                    esse
                    mesmo estado atual do imóvel que é do seu
                    conhecimento. A não-aceitação da presente proposta por parte do(s) Proprietário(s) não constitui
                    obrigação de indemnizar os proponentes, por quaisquer
                    danos que estes venham a ter por este facto.
                </div>
            </div>

            <div class="proposal-item-normal">
                <div style="width: 100%; font-size: 11px; text-align: center; font-weight: 700;">
                    Qualquer alteração a esta proposta implica o preenchimento de uma nova. Não serão aceites
                    propostas
                    rasuradas e sem assinatura das partes.
                </div>
            </div>

            <div class="proposal-item-normal">
                <div style="width: 100%; font-size: 11px;">
                    O(s) proponente(s) declara(m) e assume(m) a exatidão dos dados recolhidos no presente
                    formulário,
                    comprometendo-se a informar sobre as alterações que
                    possam surgir e que tenham relevância no cumprimento das obrigações legais por parte da
                    {{entityData.name}}.
                </div>
            </div>

            <div class="proposal-item-normal">
                <div style="width: 50%; font-weight: 700;">
                    Data:
                </div>
                <div style="width: 50%; font-weight: 700;">
                    Local:
                </div>
            </div>

            <div class="proposal-item-normal">
                <div style="width: 50%; font-weight: 700;height: 100px;">
                    Assinatura Proponente(s):
                </div>
                <div style="width: 50%; font-weight: 700;height: 100px;">
                    Assinatura e Carimbo da Empresa de Mediação:
                </div>
            </div>
        </div>
        <div class="proposal-footer">
            <span>{{entityData.name}}</span>
            <span>Página {{pagesCount - 1}} de {{pagesCount}}</span>
        </div>
    </div>
    <div class="pdf-page">
        <div class="proposal-header">
            <div class="logo">
                <img src="{{entityData?.image ? logoPath + entityData?.image : ''}}" crossorigin="anonymous">
            </div>
            <div class="block">
                <h3>{{isSaleBusinessType ?
                    'Proposta de Aquisição' : 'Proposta de Arrendamento'}}
                </h3>
            </div>
        </div>
        <div class="proposal-body">
            <div class="proposal-item-head">
                Apresentação ao Proprietário
            </div>
            <div class="proposal-item-normal">
                <div style="width: 50%;">
                    Data:
                </div>
                <div style="width: 50%;">
                    Local:
                </div>
            </div>
            <div class="proposal-item-normal">
                <div style="width: 50%;">
                    <span>Aceitação Proposta?</span>
                    <span class="mx-2">Sim</span>
                    <input type="checkbox" class="ms-2">
                    <span class="mx-2">Não</span>
                    <input type="checkbox" class="ms-2">

                    <span class="w-100">Contraproposta €:</span>
                </div>
                <div style="width: 50%; font-weight: 700;height: 120px;">
                    Assinatura Proprietário(s):
                </div>
            </div>
            <div class="proposal-item-head">
                Apresentação Contraproposta
            </div>
            <div class="proposal-item-normal">
                <div style="width: 50%;">
                    Data:
                </div>
                <div style="width: 50%;">
                    Local:
                </div>
            </div>
            <div class="proposal-item-normal">
                <div style="width: 50%;">
                    <span>Aceitação Contraproposta?</span>
                    <span class="mx-2">Sim</span>
                    <input type="checkbox" class="ms-2">
                    <span class="mx-2">Não</span>
                    <input type="checkbox" class="ms-2">

                </div>
                <div style="width: 50%; font-weight: 700;height: 120px;">
                    Assinatura Proponente(s):
                </div>
            </div>
            <div class="proposal-item-normal">
                <div style="width: 100%;">
                    A proposta deve ser integralmente preenchida, de forma legível e sem rasuras
                </div>
            </div>

            <div class="proposal-item-normal">
                <div style="width: 100%; font-size: 11px;">
                    {{entityData.name}} com sede na <span [innerHTML]="entityData.address"></span>, na qualidade de
                    mediador
                    imobiliário e em cumprimento do Regulamento (EU) 2016/679 do
                    Parlamento Europeu e do Conselho, de 27 de Abril de 2016
                    e demais legislação aplicável ao tratamento de dados pessoais, informa que os dados solicitados
                    e
                    recolhidos neste documento serão incorporados em
                    ficheiro de tratamento automatizado, com a
                    finalidade própria e exclusiva do contrato ou transação para cujos efeitos são recolhidos, pelo
                    prazo estritamente necessário. Salvo indicação contrária, os
                    dados solicitados são os estritamente necessários para análise e procedência da Proposta
                    apresentada, pelo que a recusa sobre o seu fornecimento
                    implicará a inadmissibilidade da mesma. O Proponente poderá exercer, nos termos da lei, os
                    direitos
                    de acesso, retificação, apagamento, limitação do
                    tratamento e oposição sobre os dados recolhidos, endereçando para o efeito solicitação expressa
                    nesse sentido para a morada da sede da sociedade.
                    A política de privacidade de dados da {{entityData.name}} pode ser consultada na íntegra em
                    {{entityData.website}}.
                    Os dados solicitados nesta proposta cumprem o dever de identificação imposto pelo artº 24º nº
                    1-a)
                    b) da Lei nº 83/2017 de 18 de Agosto.
                </div>
            </div>
        </div>
        <div class="proposal-footer">
            <span>{{entityData.name}}</span>
            <span>Página {{pagesCount}} de {{pagesCount}}</span>
        </div>
    </div>
</div>
